import L from "leaflet";
import deadPin from "../../assets/dead-pin.svg";
import pinBL from "../../assets/pin-bl.svg";
import pin from "../../assets/pin.svg";
import "./MarkerIcon.css";

const activeDeviceIcon = new L.Icon({
  iconUrl: pin,
  iconRetinaUrl: pin,
  iconAnchor: null,
  popupAnchor: [0, 0],
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: new L.Point(12, 12),
  className: " animate-pulse",
});

const devicePulsingLabeledDivIcon = ({ color, label }) =>
  new L.DivIcon({
    html: `<div class="flex bg-white bg-opacity-90 align-baseline items-center rounded-full py-2 px-1 shadow-sm">
    <div class=" h-2 w-2 rounded-full  animate-ping fill-current ${color}"></div>
    <div class=" relative h-2 w-2 -left-2 rounded-full fill-current ${color}"></div>
    <div class="p-1 rounded-full flex align-middle justify-center text-xs text-gray-600">${label || ""}</div>
    </div>
    `,
    className: "flex",
  });
// --- SVG FACTORIES ---------------------------------------------------------

const invertTriangle = (hasBorder) => `
<svg viewBox="0 0 140 123" xmlns="http://www.w3.org/2000/svg">
  <g transform="translate(0,123) scale(1,-1)">
    <path 
      d="M63.0718 3.99999C66.151 -1.33334 73.849 -1.33333 76.9282 4L138.416 110.5C141.495 115.833 137.646 122.5 131.488 122.5H8.51218C2.35378 122.5 -1.49521 115.833 1.584 110.5L63.0718 3.99999Z"
      fill="currentColor"
      ${hasBorder ? 'stroke="red" stroke-width="5"' : ""}
    />
  </g>
</svg>
`;

const square = (hasBorder) => `
<svg viewBox="0 0 125 125" xmlns="http://www.w3.org/2000/svg">
  <rect width="125" height="125" rx="8"
    fill="currentColor"
    ${hasBorder ? 'stroke="red" stroke-width="5"' : ""}
  />
</svg>
`;

const circle = (hasBorder) => `
<svg viewBox="0 0 126 126" xmlns="http://www.w3.org/2000/svg">
  <circle cx="63" cy="63" r="63"
    fill="currentColor"
    ${hasBorder ? 'stroke="red" stroke-width="5"' : ""}
  />
</svg>
`;

// --- LOOKUP TABLES

// Priority: ALIVE > DEAD > DEFAULT
const colorMap = {
  alive: {
    EL: "text-blue-400",
    LT: "text-blue-700",
    ELS: "text-blue-700",
    default: "text-blue-500",
  },
  dead: {
    BL: "text-yellow-400",
    default: "text-gray-400",
  },
  default: {
    BL: "text-yellow-400",
    LT: "text-blue-400",
    ELS: "text-blue-400",
    EL: "text-blue-400",
    default: "text-blue-500",
  },
};

// model → icon shape
const iconMap = {
  BL: circle,
  LT: circle,
  EL: invertTriangle,
  ELS: invertTriangle,
  default: circle,
};

// --- MAIN FUNCTION ---------------------------------------------------------

const deviceModelPulsingPin = ({ alive, model, isDraggable = false, isWatering }) => {
  // Determine if border should appear
  const hasBorder = alive === "dead" && model !== "BL";

  // Determine color
  const color = colorMap[alive]?.[model] || colorMap[alive]?.default || colorMap.default[model] || colorMap.default.default;

  // Pick icon generator
  const iconFn = iconMap[model] || iconMap.default;

  // Create SVG
  const icon = iconFn(hasBorder);

  return new L.DivIcon({
    html: `
      <div class="flex align-baseline items-center">
        <div class="h-3 w-3 ${(isWatering && alive !== "dead") ? "ripple" : ""} ${color}" ${!isDraggable ? "" : 'style="outline: dashed 2px #269EB9; border-radius: 50%;"'}>
          ${icon}
        </div>
        <div class="relative h-3 w-3 -left-3 ${color}">
          ${icon}
        </div>
      </div>
    `,
    className: "flex",
  });
};

const blDeviceIcon = new L.Icon({
  iconUrl: pinBL,
  iconRetinaUrl: pinBL,
  iconAnchor: null,
  popupAnchor: [0, 0],
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: new L.Point(12, 12),
  className: " animate-pulse",
});

const deadDeviceIcon = new L.Icon({
  iconUrl: deadPin,
  iconRetinaUrl: deadPin,
  iconAnchor: null,
  popupAnchor: [0, 0],
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: new L.Point(8, 8),
  className: "",
});

export { activeDeviceIcon, blDeviceIcon, deadDeviceIcon, deviceModelPulsingPin, devicePulsingLabeledDivIcon };
